import cx from "clsx";
import React from "react";

import styles from "./index.module.scss";

type Size = `${number}${"px" | "em"}`;

type OwnProps = {
  className?: string;
  style?: React.CSSProperties;
  size?: Size;
  icon: React.ReactNode;
};

type ForwardedProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

type Props = OwnProps &
  Omit<ForwardedProps, keyof OwnProps | "children" | "content">;

const ButtonIcon: React.ForwardRefExoticComponent<Props> = React.forwardRef<
  HTMLButtonElement,
  Props
>(function ButtonIcon(
  { className, style, icon, size = "1.2em", ...others }: Props,
  ref
) {
  return (
    <button
      className={cx(styles.container, className)}
      style={{ ...style, ...(size ? { width: size, height: size } : {}) }}
      ref={ref}
      {...others}
    >
      {icon}
    </button>
  );
});

export default ButtonIcon;
